import { render, staticRenderFns } from "./WechatRevenue.vue?vue&type=template&id=99cf53c8&scoped=true"
import script from "./WechatRevenue.vue?vue&type=script&lang=js"
export * from "./WechatRevenue.vue?vue&type=script&lang=js"
import style0 from "./WechatRevenue.vue?vue&type=style&index=0&id=99cf53c8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf53c8",
  null
  
)

export default component.exports